import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { api } from "@/lib/api";

export function RequestTaxiDialog({ open, onOpenChange, search }) {
  const [form, setForm] = useState({ name: "", phone: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async () => {
    if (!form.name || !form.phone || !form.email) { toast.error("Please fill in your name, phone and email"); return; }
    setLoading(true);
    try {
      const { data } = await api.post("/leads", {
        pickup: search?.pickup || { name: "", lat: 51.5, lng: -0.12 }, dropoff: search?.dropoff,
        date: search?.date || "", time: search?.time || "", passengers: search?.passengers || 1,
        vehicle_key: search?.vehicle_key || "any", service_type: search?.service_type || "local",
        ...form,
      });
      toast.success(`Request received (${data.id}). We'll try to find an available taxi and contact you shortly.`);
      onOpenChange(false);
    } catch { toast.error("Could not submit request"); }
    finally { setLoading(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="request-taxi-dialog">
        <DialogHeader><DialogTitle className="font-heading">Request a Taxi</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-500">We'll try to find an available taxi for your journey and get back to you with a fare.</p>
        <div className="grid gap-3">
          <div><Label>Full name</Label><Input value={form.name} onChange={set("name")} data-testid="req-name" placeholder="John Smith" /></div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label>Phone</Label><Input value={form.phone} onChange={set("phone")} data-testid="req-phone" placeholder="+44…" /></div>
            <div><Label>Email</Label><Input value={form.email} onChange={set("email")} data-testid="req-email" placeholder="you@email.com" /></div>
          </div>
          <div><Label>Message (optional)</Label><Textarea value={form.message} onChange={set("message")} data-testid="req-message" placeholder="Any details about your journey" /></div>
        </div>
        <DialogFooter>
          <Button onClick={submit} disabled={loading} className="bg-brand hover:bg-brand/90" data-testid="req-submit">{loading ? "Sending…" : "Submit Request"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
